import $ from "jquery";
export default function magazinListPostForCategory() {

    let totalPageCount = 1;
    let currentPage = 1;

    function loadPostsByCategory(category_id, current_post_id, page) {
        let loadingSpinner = $('#loading-spinner');
        loadingSpinner.show();
        $('#avu-magazin-post-list').hide();

        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                action: 'filter_posts_by_category',
                category_id: category_id,
                current_post_id: current_post_id,
                paged: page,
            },
            success: function (response) {
                loadingSpinner.hide();
                $('#avu-magazin-post-list').html(response);
                $('#avu-magazin-post-list').show();

                //Pagination
                totalPageCount = $('.single-page').length;
                if(totalPageCount > 3) {
                    if (currentPage < 3) {
                        $('.single-page').addClass("hide-page");
                        $('#page-1').removeClass("hide-page");
                        $('#page-2').removeClass("hide-page");
                        $('#page-3').removeClass("hide-page");
                    }
                    if (currentPage >= 3) {
                        $('.single-page').addClass("hide-page");
                        $('#page-'+ (currentPage + 1)).removeClass("hide-page");
                        $('#page-'+ (currentPage)).removeClass("hide-page");
                        $('#page-'+ (currentPage - 1)).removeClass("hide-page");
                    }
                }
                if (currentPage == 1) {
                    $('.avu-pagination-page-prev').addClass("avu-pagination-prev-disable");
                }
                if (currentPage == totalPageCount) {
                    $('.avu-pagination-page-next').addClass("avu-pagination-next-disable");
                }


            },
            error: function () {
                loadingSpinner.hide();
            }
        });
    }



    $(document).ready(function () {
        let current_post_id_all = $('#all-avu-magazin-article').attr('data-current-post-id');

        loadPostsByCategory('alle', current_post_id_all, currentPage);

        $('ul.categories-list li').on('click', function () {
            $('ul.categories-list li').removeClass("current");
            $(this).addClass("current");
            let category_id = $(this).data('category-id');
            let current_post_id = $(this).data('current-post-id');
            currentPage = 1;
            loadPostsByCategory(category_id, current_post_id, currentPage);
            $('#collapseMagazinCategory').removeClass("show");
            $('#collapseMagazinCategoryButton').addClass("collapsed");
            $('#collapseMagazinCategoryButton').attr("aria-expanded","false");
        });

        $(document).on('click', '.pagination a', function (e) {
            e.preventDefault();
            let page = $(this).data('paged');
            currentPage = page;
            let category_id = $('ul.categories-list li.current').data('category-id');
            let current_post_id = $('ul.categories-list li.current').data('current-post-id');
            loadPostsByCategory(category_id, current_post_id, currentPage);
            $("html, body").animate({
                scrollTop: 1020
            }, 0);

        });

    });

}







